<template>
  <div class="component rotate-device">
    <div class="logo">
      <img src="/logo-chervo.svg" alt="">
    </div>
    <span>Please<br>rotate your<br>device</span>
  </div>
</template>

<script>
export default {
  name: 'RotateDevice',
};
</script>

<style lang="scss" scoped>
@import '~sass-mq';

$mq-breakpoints: (
  mobileS: 320px,
  mobile: 375px,
  mobileX: 414px,
  mobileL: 568px,
  ipadP: 768px,
  ipadL: 1024px,
  ds: 1280px,
  d: 1440px,
  dm: 1680px,
  dl: 1920px,
  dxl: 2560px,
);

$is-landscape: '(orientation: landscape)';
$is-portrait: '(orientation: portrait)';
$is-iphonex: '(device-height: 812px) and (-webkit-device-pixel-ratio : 3)';
$is-ipadpro: '(max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 1.5)';
$is-touch-device: '(pointer: coarse) and (hover: none)';
$is-not-touch-device: '(pointer: fine) and (hover: hover)';
$is-ie-11: '(-ms-high-contrast: active) and (-ms-high-contrast: none)';
$is-height-small: '(max-height: 767px)';

.rotate-device {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;

  z-index: 999;

  display: none;
  align-items: center;
  justify-content: center;

  background-color: #09473a;

  text-align: center;
  color: white;
  font-size: 1.4em;

  @include mq($until: ipadL, $and: '(orientation: landscape)') {
    display: flex;
  }

  @include mq($and: $is-not-touch-device) {
    display: none;
  }

  .logo {
    position: absolute;
    top: 20px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
